import Controller from '@ember/controller';

export default class DeliveriesLogTutorialController extends Controller {}
